import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, UserCheck, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button, CHECKOUT_URL } from '../ui/Button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/7UdPKmMqGN2kBcDwqPJnm3/ChatGPT_Image_Jun_6__2026__12_53_55_PM-removebg-preview.png';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-16 pb-20 md:pt-24 md:pb-28 overflow-hidden" data-id="element-35">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 text-white/80 text-xs font-bold tracking-wider uppercase mb-8 border border-white/10" data-id="element-37">
          DOMINÁ TU PRIMER TRIATLÓN
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.15] mb-10 max-w-3xl" data-id="element-38">
          El sistema definitivo para tu primer{' '}
          <span className="text-brand-green" data-id="element-39">triatlón</span>
        </motion.h1>

        <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="block w-full mb-10 cursor-pointer group" data-id="element-40">
          <img src={PRODUCT_IMAGE} alt="Triatlón en 6HS Product Bundle" className="w-[80%] max-w-2xl mx-auto h-auto object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-41" />
        </motion.a>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="font-serif italic text-xl md:text-2xl text-white/80 mb-8 max-w-3xl" data-id="element-42">
          Un sistema ideal para principiantes y atletas que quieren dejar de
          improvisar.
        </motion.p>

        <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-43">
          {[{
          icon: <FileText size={16} data-id="element-44" />,
          label: 'PDF digital'
        }, {
          icon: <Zap size={16} data-id="element-45" />,
          label: 'Acceso inmediato'
        }, {
          icon: <UserCheck size={16} data-id="element-46" />,
          label: 'Para principiantes'
        }].map(chip => <div key={chip.label} className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full border border-white/10 text-sm font-medium text-white/90" data-id="element-47">
              <span className="text-brand-green" data-id="element-48">{chip.icon}</span>
              {chip.label}
            </div>)}
        </div>

        <Button href={CHECKOUT_URL} className="px-8 py-4 text-base md:text-lg mb-4" data-id="element-49">
          → QUIERO DESBLOQUEAR MI PRIMER TRIATLÓN
        </Button>

        <div className="flex flex-wrap justify-center items-center gap-2 text-xs text-white/60 font-medium" data-id="element-50">
          <div className="flex items-center gap-1" data-id="element-51">
            <ShieldCheck size={14} className="text-brand-green" data-id="element-52" />
            Garantía 7 días
          </div>
          <span className="text-white/20" data-id="element-53">•</span>
          <div className="flex items-center gap-1" data-id="element-54">
            <Lock size={14} className="text-brand-green" data-id="element-55" />
            Pago 100% seguro
          </div>
          <span className="text-white/20" data-id="element-56">•</span>
          <div className="flex items-center gap-1" data-id="element-57">
            <CreditCard size={14} className="text-brand-green" data-id="element-58" />
            Mercado Pago | Tarjeta
          </div>
        </div>
      </div>
    </section>;
}